import type { OrganizationDto } from "common/models/api/models/OrganizationDto";
import useUserState from "ui/adapter/state/useUserState";

export default function useSelectedOrganization(): OrganizationDto | undefined {
    const { selectedRole } = useUserState();
    return selectedRole?.organization;
}
